<template>
  <base-section id="theme-features">
    <base-section-heading title="HEQ Tokens" />

    <v-container>
      <v-row>
        <v-col
          v-for="(feature, i) in features"
          :key="i"
          cols="12"
          md="6"
        >
          <router-link
            style="text-decoration: none; color: inherit;"
            :to="{
              name: feature.routeName,
              params: {'loanConfiguration': feature.loanConfiguration}
            }"
            class="d-block"
          >
            <base-avatar-card
              v-bind="feature"
              align="left"
              horizontal
            >
              {{ feature.description }}
            </base-avatar-card>
          </router-link>
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionHeqToken',

    data: () => ({
      features: [
        {
          title: 'White Paper',
          icon: 'mdi-file-outline',
          description: 'The Origin Story',
          routeName: 'White Paper',
        },
        {
          title: 'Blockchain',
          icon: 'mdi-vector-link',
          description: 'Built on a modern and secure platform with the future in mind.',
          routeName: 'Blockchain',
        },
        {
          title: 'The HEQ-Card-Wallet',
          icon: 'mdi-cash',
          description: 'Your crytpo wallet is now a "smart" card.  The HEQ-Card-Wallet is accepted anywhere VISA and Mastercard are accepted.',
          routeName: 'Wallet',
        },
        {
          title: 'The HEQ Tokens',
          icon: 'mdi-bitcoin',
          description: 'The highly liquid real estate-backed stablecoins.',
          routeName: 'Token',
        },
      ],
    }),
  }
</script>
